@if (breadcrumbs.length > 0) {
  <div class="page-header">
    <div class="page-block">
      <div class="row align-items-center">
        <div class="col-md-12 px-2">
          <ul class="breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/dashboard']">
                <i class="icon home-icon"></i>
              </a>
            </li>

            @for (breadcrumb of breadcrumbs; track $index; let last = $last) {
              <div class="breadcrumb-i">
                <i class="pi pi-chevron-right"></i>
              </div>

              <li class="breadcrumb-item" [class.active]="last">
                @if (!last && breadcrumb.route && !breadcrumb.submodules) {
                  <a [routerLink]="getBreadcrumbLink(breadcrumb.route)">
                    {{ breadcrumb.name | translate }}
                  </a>
                } @else if (breadcrumb.submodules && breadcrumb.submodules.length > 0) {
                  <p-select
                    [options]="breadcrumb.submodules"
                    optionValue="moduleRoute"
                    [(ngModel)]="breadcrumb.route"
                    (onChange)="onCategoryChange($event)"
                    dropdownIcon="pi pi-sort-down-fill"
                    [filter]="false"
                    [showClear]="false"
                    appendTo="body">

                    <ng-template let-option pTemplate="item">
                      <div class="dropdown-item" (click)="onCategoryChange(option)">{{ option.moduleName | translate }}</div>
                    </ng-template>
                    
                    <ng-template let-selectedOption pTemplate="selectedItem">
                      {{ selectedOption.moduleName | translate }}
                    </ng-template>
                  </p-select>
                  
                } @else {
                  <span>{{ breadcrumb.name | translate}}</span>
                }
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
}